import type { JSX } from 'react';

import { Loader2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';

import type { Webhook } from '../types/webhook';

interface WebhooksDeleteDialogProps {
  deleteTarget: Webhook | null;
  isDeleting: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const WebhooksDeleteDialog = ({
  deleteTarget,
  isDeleting,
  onClose,
  onDelete,
}: WebhooksDeleteDialogProps): JSX.Element => {
  return (
    <Dialog
      open={deleteTarget !== null}
      onOpenChange={(next) => {
        if (!next) {
          onClose();
        }
      }}
    >
      <DialogContent className="gap-4 sm:max-w-sm" showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>Eliminar webhook</DialogTitle>
        </DialogHeader>
        <p className="m-0 text-sm text-muted-foreground">
          ¿Eliminar el webhook <strong className="text-foreground">{deleteTarget?.name}</strong>? Esta acción no se
          puede deshacer.
        </p>
        <DialogFooter className="border-t-0 bg-transparent p-0 sm:justify-end">
          <Button type="button" variant="outline" disabled={isDeleting} onClick={onClose}>
            Cancelar
          </Button>
          <Button type="button" variant="destructive" disabled={isDeleting} className="gap-2" onClick={onDelete}>
            {isDeleting ? <Loader2 className="size-4 animate-spin" aria-hidden /> : null}
            Eliminar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default WebhooksDeleteDialog;
